import cartActionTypes from '../cart/actionTypes';
import createReducer from '../utils/createReducer';

const initialState = {
  itemDebugData: {},
};

function mapKeysAndValues(listOfAttributes) {
  const atts = {};
  listOfAttributes.forEach(att => {
    if (att.key) {
      atts[att.key] = att.value;
    }
  });
  return atts;
}

function invalidCheckoutValidityChecks(validityChecks) {
  const fails = validityChecks
    .filter(
      check =>
        !check.valid &&
        check.name !== 'payment' &&
        check.name !== 'customerCommitted'
    )
    .map(check => check.name);

  return fails.join(',');
}

/**
 * Reducer for 'state.debug' portion of Redux state.
 */
export default createReducer(initialState)({
  [cartActionTypes.CART_LOAD_SUCCESS]: (state, { cart }) => {
    const itemDebugData = {};

    cart.lineItems.forEach(lineItem => {
      const itemId = lineItem.id;

      // itemDebugData for an item is a 'dictionary of dictionaries'.
      // each top level dictionary is a 'heading' in the item debug view
      // each entry in the subdictionary is displayed as a piece of information in the debug view
      // - entries whose keys end in 'Data' are assumed to be rich JSON objects, and will not be displayed (but will be copyable)
      // - entries whose keys end in 'Url' are assumed to be URLs and will be hyperlinked (and copyable)
      // - all other entries will be displayed as some sort of text (arrays and objects will be stringified)

      itemDebugData[itemId] = {
        vistacart: {
          itemId,
          shopperId: cart.shopperId,
          tenantName: cart.tenantName,
          expectedOrderId: cart.checkoutData?.expectedOrderId,
          cartType: cart.cartType,
          cartLastModified: cart.lastModifiedAt,
        },
        product: {
          key: lineItem.productData?.productKey,
          version: lineItem.productData?.productVersion,
          attributeData: mapKeysAndValues(
            lineItem.productData?.selectedAttributes || []
          ),
          quantity: lineItem.quantity,
          templateTenant: lineItem.cartTemplateReference?.tenantName,
          templateId: lineItem.cartTemplateReference?.cartTemplateId,
        },
        mcp: {
          sku: lineItem.fulfillmentData?.mcpProductId,
          version: lineItem.fulfillmentData?.mcpProductVersion,
          productConfigUrl: lineItem.fulfillmentData?.mcpProductConfigUrl,
        },
        design: {
          hasDoc: !!lineItem.designData?.documentReferenceUrl,
          documentReferenceUrl: lineItem.designData?.documentReferenceUrl,
        },
        validity: {
          itemValid: !!lineItem.customOrderData?.checkout?.validForCheckout,
          finalPricing: lineItem.pricingData?.readyForCheckout,
          pricingStatus: lineItem.pricingData?.pricingStatusKey,
          podsValidityFailure:
            lineItem.customOrderData?.checkout?.podsCheckoutDisabledReasons,
          externalValidity:
            lineItem.validityData?.validationAuthorityKey === 'NOOP'
              ? undefined
              : lineItem.validityData?.itemValidityStatus,
          externalValidityAuthority:
            lineItem.validityData?.validationAuthorityKey === 'NOOP'
              ? undefined
              : lineItem.validityData?.validationAuthorityKey,
          externalValidityResultReason:
            lineItem.validityData?.additionalItemValidityData
              ?.validationResultReason,
          templateReadyToBeginCheckout: lineItem.cartTemplateReference
            ? lineItem.cartTemplateReference?.cartTemplateSummary
                ?.checkoutValidity?.readyToBeginCheckout
            : undefined,
          templateIssues:
            !lineItem.cartTemplateReference ||
            lineItem.cartTemplateReference?.cartTemplateSummary
              ?.checkoutValidity?.readyToBeginCheckout
              ? undefined
              : invalidCheckoutValidityChecks(
                  lineItem.cartTemplateReference?.cartTemplateSummary
                    ?.checkoutValidity?.validityChecks || []
                ),
        },
        developer: {
          customOrderData: lineItem.customOrderData,
          templateCustomOrderData:
            lineItem.cartTemplateReference?.cartTemplateSummary
              ?.customOrderData,
        },
      };
    });

    return { itemDebugData };
  },
  [cartActionTypes.CART_CLEAR]: () => initialState,
});
